import React from 'react'

import {
  StyleSheet,
  View,
  ScrollView,
  Text,
  Dimensions,
  TouchableOpacity
} from 'react-native'

import { useContent } from '@sart/content'

import client, { useClient } from '@sart/client'
import {
  colors, typography, backgroundColors, adaptive
} from '@sart/styles'
import {
  Space,
  ServiceItem
} from '@sart/components'
import {
  CompanyIcon,
  ProductIconType
} from '@sart/icons'

import { SafeAreaView } from 'react-native-safe-area-context'

export default function Dashboard(props) {
  const { navigation } = props
  const content = useContent()

  const {
    cache: {
      services
    } = {}
  } = useClient()

  return (
    <SafeAreaView>
      <ScrollView style={styles.container}>
        <View style={styles.row}>
          <CompanyIcon color={colors.srGreen} height={60} width={60} />
          <Text style={styles.title}>{content.selectService.title}</Text>
        </View>
        {services && services.map(service => {
          return (
          <View>
            <ServiceItem
              serviceType={service.serviceType}
              serviceId={service.lineIdentifier}
              serviceDescription={content.selectService[service.billingMode.toLowerCase()][service.serviceType.toLowerCase()]}
              iconColor={colors.white}
            />
            <Space height={18} />
        </View>)})
        }
      </ScrollView>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: Dimensions.get('window').width,
    ...adaptive.wrapperPadding,
  },
  row: {
    flexDirection: 'row',
    width: '100%',
  },

  title: {
    ...typography.bold,
    color: colors.srDarkGreen,
    fontSize: 22,
    alignSelf: 'center',
    textAlign: 'center',
    width: 265
  }
})

